module.exports = __webpack_public_path__ + "img/11088035_L.e55738b1.png";